import { render, staticRenderFns } from "./VisualIdentity.vue?vue&type=template&id=3763c1db&scoped=true&"
import script from "./VisualIdentity.vue?vue&type=script&lang=js&"
export * from "./VisualIdentity.vue?vue&type=script&lang=js&"
import style0 from "./VisualIdentity.vue?vue&type=style&index=0&id=3763c1db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3763c1db",
  null
  
)

export default component.exports